export default {
  namespaced: true,

  state: {
    deviceLocale: 'en-US'
  },

  mutations: {
    SET_DEVICE_LOCALE(state, locale) {
      state.deviceLocale = locale;
    }
  }
};
